import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import NotesCell from '../Cells/NotesCell';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const notesDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Notes',
	minWidth: 60,
	width: 60,
	headerName: 'Notes',
	display: 'flex',
	align: 'center',
	renderHeader: () => <RenderHeader primaryText='Notes' />,
	renderCell: NotesCell,
	sortable: false,
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row) => {
				return row.hasNotes ? caseInsensitiveIncludes(value, ['Notes']) : false;
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.hasNotes
};

export default notesDefinition;
